/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartialDischarges } from './partialDischarges';


export interface StatusCodeValuePartialDischarges { 
    value?: PartialDischarges;
    status_code?: number;
}

